module.exports = __webpack_public_path__ + "static/media/brush-settings-1.9ead62f5.gif";